import type { InputHTMLAttributes } from "react"
import { cn } from "@/lib/cn"

// Single-line text input. Keeps the dark-surface look — every form on the
// portal pulls this rather than styling raw <input>s ad-hoc.
type Props = InputHTMLAttributes<HTMLInputElement>

export function Input({ className, ...rest }: Props) {
  return (
    <input
      {...rest}
      className={cn(
        "rounded-control border border-border bg-white/5 px-3 py-2 text-sm text-app-text",
        "placeholder:text-app-subtle outline-none transition focus:border-brand-red/50",
        "disabled:opacity-50 disabled:pointer-events-none",
        className,
      )}
    />
  )
}
